import styled from 'styled-components';

export const HowItWorksContainer = styled.section`
    padding-bottom: ${props => (props.noPadding ? '0' : '60px')};

    &.cmt-ca-marche-shadow {
        -webkit-box-shadow: 0 -5px 10px rgba(0, 0, 0, 0.12);
        -moz-box-shadow: 0 -5px 10px rgba(0, 0, 0, 0.12);
        box-shadow: 0 -5px 10px rgba(0, 0, 0, 0.12);
    }

    .styledButton {
        width: 240px;
        position: relative;
        margin-bottom: 10px;
        background-color: ${props => props.theme.white};
        border-color: ${props => props.theme.black};
        border-width: 2px;
        color: ${props => props.theme.black};

        & + .styledButton {
            margin-left: 10px;
        }
    }

    .styledButton.disabled {
        background-color: ${props => props.theme.black};
        border-color: ${props => props.theme.black};
        color: ${props => props.theme.white};

        &:hover {
            opacity: 1;
        }

        &:after {
            top: 100%;
            left: 50%;
            border-style: solid;
            border-image: none 100% / 1 / 0 stretch;
            content: ' ';
            height: 0px;
            width: 0px;
            position: absolute;
            border-color: ${props => props.theme.black} transparent transparent;
            border-width: 9px;
            margin-left: -9px;
        }
    }

    .buttonWrapper {
        display: flex;
        justify-content: center;
        padding-bottom: 20px;
    }

    @media screen and (max-width: ${props => props.theme.large}) {
        .styledButton {
            font-size: 13px;
        }
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        .styledButton {
            width: 50%;
            min-width: 240px;

            &.disabled {
                &:after {
                    display: none;
                }
            }

            & + .styledButton {
                margin-left: 0;
            }
        }

        .buttonWrapper {
            flex-direction: column;
            align-items: center;
        }
    }

    @media screen and (max-width: ${props => props.theme.tiny}) {
        .styledButton {
            width: 240px;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/HowItWorksComponentStyle.js